var lastUsed = 0;
export var getElementId = function (name) {
    if (name === void 0) { name = ""; }
    return "" + name + (name !== "" ? "-" : "") + "element-" + lastUsed++;
};
